// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"e4d0f899","977":"a89da2a0"}[chunkId] + ".chunk.js";
};